import React from "react";
import {
  lifecycle,
  compose,
  branch,
  renderNothing,
  renderComponent,
  withProps,
  setDisplayName
} from "recompose";
import { connect } from "react-redux";
import { actions } from "../../modules/contracts";
import TryAgain from "../../components/TryAgain";
import Loading from "../../components/Loading";
import { objectToQueryString } from "../../helpers/index";

const failed = ({
  failFetchContracts,
  fetchingContracts,
  successFetchContracts
}) => failFetchContracts && !fetchingContracts && !successFetchContracts;

const isFetching = ({
  failFetchContracts,
  fetchingContracts,
  successFetchContracts
}) => fetchingContracts && !failFetchContracts && !successFetchContracts;
const isInitial = ({
  failFetchContracts,
  fetchingContracts,
  successFetchContracts,
  contracts
}) =>
  !failFetchContracts &&
  !fetchingContracts &&
  !successFetchContracts &&
  !contracts;
const hasNoContracts = ({ contracts }) => !contracts;

const nonOptimalStates = states =>
  compose(...states.map(state => branch(state.when, state.render)));

const TryAgainContract = ({ failFetchContracts, ...props }) => (
  <TryAgain
    label={failFetchContracts}
    onTryAgain={fetchContractsCallback(props)}
  />
);

export const withFetchingStates = nonOptimalStates([
  {
    when: isFetching,
    render: renderComponent(withProps({ label: "Loading Contracts" })(Loading))
  },
  { when: failed, render: renderComponent(TryAgainContract) },
  { when: isInitial, render: renderNothing },
  { when: hasNoContracts, render: renderNothing }
]);

export const sortContractsByDate = contracts =>
  contracts.sort(
    (previousContract, nextContract) =>
      Date.parse(nextContract.created_at) -
      Date.parse(previousContract.created_at)
  );

const fetchContractsCallback = ({
  role,
  currentDealer,
  fetchContracts,
  user,
  setContracts,
  currentPage,
  perPage,
  searchSnapshot
}) => () => {
  if (user) {
    if (role === "staff" && currentDealer) {
      fetchContracts({
        dealer_id: currentDealer.id,
        query_string: objectToQueryString({
          page: currentPage,
          per_page: perPage,
          ...searchSnapshot
        })
      });
    } else {
      setContracts(sortContractsByDate(user.contracts));
    }
  }
};

export const withFetchContracts = lifecycle({
  componentDidMount() {
    fetchContractsCallback(this.props)();
  },
  componentWillReceiveProps(nextProps) {
    const { user, role } = this.props;
    if (role === "customer") {
      if (user !== nextProps.user) {
        fetchContractsCallback(
          Object.assign({}, this.props, { user: nextProps.user })
        )();
      }
    }
  },
  componentWillUnmount() {
    this.props.resetState();
  }
});

const mapStateToProps = state => ({
  fetchingContracts: state.contracts.fetchingContracts,
  failFetchContracts: state.contracts.failFetchContracts,
  contracts: state.contracts.contracts,
  searchSnapshot: state.contracts.searchSnapshot,
  currentDealer: state.dealers.currentDealer,
  perPage: state.contracts.perPage,
  currentPage: state.contracts.currentPage,
  totalPages: state.contracts.totalPages,
  role: state.settings.role,
  user: state.auth.user
});

const mapDispatchToProps = {
  fetchContracts: actions.fetchContracts,
  fetchCustomerContracts: actions.fetchCustomerContracts,
  setContracts: actions.setContracts,
  setCurrentPage: actions.setCurrentPage,
  setPerPage: actions.setPerPage,
  resetState: actions.resetState
};

export default compose(
  setDisplayName("WithFetchContracts"),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withFetchContracts,
  withFetchingStates
);
